<template>
  <router-view />
</template>

<script>
export default {
  name: 'Projects'
}
</script>
